import { useAuthInterface } from '@/composables/useAuthInterface';

export const AuthPlugin = {
  install(Vue, { store }) {
    if (!store) {
      Vue.prototype.$log('AuthPlugin', 'Vuex store not provided in options', 'E');
      return;
    }

    Vue.prototype.$auth = useAuthInterface(store);
  }
};
